import {FC} from "react";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {PlayerPositionEnum} from "modules/enums";
import {getPlayerById} from "modules/selectors";
import {ITeam, Nullable} from "modules/types";
import {RowItem} from "./RowItem";
import {breakpoints} from "assets/theme";

const PlayerRowElement = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin-bottom: 40px;

	@media screen and (max-width: ${breakpoints.mobile}) {
		margin-bottom: 28px;
	}
`;

interface IRowProps {
	players: PlayerPositionEnum[];
	team: ITeam;
}

export const PlayersRow: FC<IRowProps> = ({players, team}) => {
	return (
		<PlayerRowElement className="field-fow">
			{players.map((position) => (
				<RowHandler playerId={team.lineup[position]} position={position} key={position} />
			))}
		</PlayerRowElement>
	);
};

export interface IRowProp {
	position: PlayerPositionEnum;
	playerId: Nullable<number>;
}

const RowHandler: FC<IRowProp> = ({position, playerId}) => {
	const player = useSelector(getPlayerById)(playerId);

	if (!player) {
		return null;
	}

	return <RowItem player={player} position={position} />;
};
